import React, { useState, useContext, useEffect } from "react";
import { ProfileCardSection } from "./ProfileCardSection";
import { RBButton, RBButtonType } from "../../../components/RBButton";
import { Spacing, Colors } from "../../../theme/Theme";
import { renderTextWithTitleAndChildComponent } from "../../../components/TextWithHeader";
import { RBTextFieldForForm, RBTextFieldForFormFieldType } from "../../../components/RBTextField";
import { ColumnStyle } from "../../../theme/ComponentTheme";
import { RBContext } from "../../../components/RBContext";
import { TextField } from "@material-ui/core";
import { AuthService } from "../../../api/AuthService";
import { AccountInfoContext } from "../../../components/AccountInfoContext";

interface AboutMeSectionProps {
  accountInfo: any;
}

export const AboutMeSection: React.FC<AboutMeSectionProps> = ({ ...props }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [aboutMeText, setAboutMeText] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const { secondaryColor, primaryColor } = useContext(RBContext);

  const { accountInformation } = useContext(AccountInfoContext);
  useEffect(() => {
    setAboutMeText(accountInformation.pharmacist.about || "");
  }, [ accountInformation ]);

  const renderDetail = () => {
    return (
      <>
        {renderTextWithTitleAndChildComponent("", 
          <div style={{ width: "100%" }}>
            {isEdit ? (
              <TextField
                name="aboutMe"
                value={aboutMeText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAboutMeText(e.target.value)}
                placeholder="Please provide a brief description of yourself and your work experience. This will be visible by locations when you apply."
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                inputProps={{ maxLength: 600 }}
                disabled={!isEdit}
                style={{ color: aboutMeText ? 'black' : Colors.darkGrey }}
              />
            ) : (
              <div style={{ color: aboutMeText ? Colors.black : Colors.darkGrey, fontWeight: aboutMeText ? "bold" : "normal", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                {aboutMeText || "Please provide a brief description of yourself and your work experience. This will be visible by locations when you apply."}
              </div>
            )}
            {isEdit && (
              <>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                <div style={{ color: Colors.darkGrey, fontSize: '12px', marginTop: '4px', textAlign: 'right' }}>
                  {Math.min(aboutMeText.length, 600)}/600 characters
                </div>
                {aboutMeText.length === 600 && (
                  <div style={{ color: 'red', fontSize: '12px', textAlign: 'right' }}>
                    Maximum character limit reached
                  </div>
                )}
              </div>
              </>
            )}
          </div>
        )}
      </>
    );
  };

  const editDetail = () => {
    return (
      <>
        {renderTextWithTitleAndChildComponent("", 
          <div style={{ width: "100%" }}>
            <TextField
              name="aboutMe"
              value={aboutMeText}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAboutMeText(e.target.value)}
              placeholder="Please provide a brief description of yourself and your work experience. This will be visible by locations when you apply."
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              inputProps={{ maxLength: 600 }}
              style={{ color: aboutMeText ? 'black' : Colors.darkGrey }}
            />
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
            <div style={{ color: Colors.darkGrey, fontSize: '12px', marginTop: '4px', textAlign: 'right' }}>
              {Math.min(aboutMeText.length, 600)}/600 characters
            </div>
            {aboutMeText.length === 600 && (
              <div style={{ color: 'red', fontSize: '12px', textAlign: 'right' }}>
                Maximum character limit reached
              </div>
            )}
            </div>
          </div>
        )}
      </>
    );
  };

  const renderAction = () => {
    const buttonText = aboutMeText ? "Edit" : "Add";
    return (
      <>
        {isEdit ? (
          <>
            <RBButton
              text="Cancel"
              buttonType={RBButtonType.cancel}
              style={{ marginRight: Spacing.medium }}
              onClick={() => setIsEdit(false)}
            />
            <RBButton 
              text="Save" 
              isLoading={isSaving}
              onClick={async () => {
                setIsSaving(true);
                try {
                  await AuthService.updateWorker({ about: aboutMeText });
                  setIsEdit(false);
                } catch (error) {
                  console.error('Failed to update About Me section:', error);
                } finally {
                  setIsSaving(false);
                }
              }}
              buttonBackgroundColor={secondaryColor}
            />
          </>
        ) : (
          <RBButton text={buttonText} onClick={() => setIsEdit(true)} buttonBackgroundColor={secondaryColor} />
        )}
      </>
    );
  };

  return (
    <ProfileCardSection
      sectionHeader="About Me"
      detail={isEdit ? editDetail() : renderDetail()}
      action={renderAction()}
    />
  );
}; 